import { Box } from '@mui/material'

export default function Footer() {
    return (
        <Box className="footer">
            <Box>© 2024 Pandium</Box>
        </Box>
    )
}
